import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { TrackingHistories, TrackingHistory } from '../../service/history';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Section } from '../model/inaSchoolEnrollments';
import { InaService } from '../../service/ina.service';

@Component({
  selector: 'app-past-edit',
  templateUrl: './past-edit.component.html',
  styleUrls: ['./past-edit.component.scss']
})
export class PastEditComponent implements OnInit,OnChanges {
  trackHistories: TrackingHistories=new TrackingHistories();
  @Input('section') section: Section;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = ['date', 'modified', 'field', 'previousValue'];
  dataSource=new MatTableDataSource<TrackingHistory>();
  constructor(private inaService: InaService) { }

  ngOnInit(): void {
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == this.section.SectionID.toString());        
        
        this.dataSource.data=this.trackHistories.inaHistory;
      }

    });


    
  }
  ngOnChanges(): void {         
    
  }
  ngAfterViewInit() {        
    this.dataSource.paginator = this.paginator;
  }
  getFieldName(fieldName:string) : string
  {
    let questionId:string=fieldName.split(',')[1];
    if(questionId=='346')    
      return 'Comments';
    else if(questionId=='498')
      return 'Updated by';
    else
      return this.section.Questions.find(x=>x.Id== Number(questionId))?.Name!;

  }
}



